/**
 * @module cache
 */
import store from '@/store'
import {
  getPortionCacheVersions,
  loadAllBasicInfo,
  loadSpecificBasicInfo,
  initCache,
  updateCacheSpecificBasicData
} from '@/api/cache'
import lodash from 'lodash'
import { basicCacheKeys as cacheKeys, basicDataCacheKeyPrefix } from './cacheConfig'
import * as CommonUtil from '@/utils/commonUtil'
import { cache } from '@/utils/cacheManager'
import $store from '@/store'
import checkPermission from '@/utils/permission'
import { resolveLocalCacheSpecificField2ValueIgnoreCase } from '@/utils/localDataCache'
import {
  METHOD_PARAMS_KEY_COMPANY_LOB
} from '@/class/cargo/model/parameters/SystemConstants'
export { cacheKeys, basicDataCacheKeyPrefix }
/**
 * 基本数据的缓存定义
 */
/** * 基本数据的缓存控件
 * @type {Map<any, any>}
 */
let basicDataCacheMap = new Map()

// 公司（包括子公司）对应的所有数据
const officeAllDepartmentMap = new Map()

export const basicCacheConfig = {

}

// todo
// export async function getAllBasicData(refreshCache = false) {
// }

export async function getSpecificBasicData(cacheKey, refreshCache = false) {
  let result = []
  if (refreshCache) {
    await syncSpecificBasicData()
  }
  if (basicDataCacheMap.has(cacheKey)) {
    result = basicDataCacheMap.get(cacheKey)
  }
  return result
}
export function getSpecificBasicDataFromCache(cacheKey) {
  let result = []
  if (basicDataCacheMap.has(cacheKey)) {
    result = basicDataCacheMap.get(cacheKey)
  }
  return result
}

/**
 * 根据字段值解析为转换后的值
 * @param cacheKey
 * @param sourceField
 * @param sourceValue
 * @param targetField
 * @param refreshCache
 * @returns {Promise<[]>}
 */
export function resolveSpecificField2Value(cacheKey, sourceField = '', sourceValue, targetField, isNeedObject) {
  let result = []
  if (basicDataCacheMap.has(cacheKey)) {
    result = basicDataCacheMap.get(cacheKey)
  }

  // console.log('sourceValue', sourceValue, sourceField, targetField)
  let targetValue = ''
  if (sourceField && targetField) {
    const entity = result.find(item => {
      return item[sourceField] == sourceValue
    })
    if (entity) {
      if (isNeedObject) {
        targetValue = entity
      } else {
        targetValue = entity[targetField] || ''
      }
    }
  }
  // console.log(cacheKey, 'targetValue', targetValue)
  return targetValue
}

export function resolveCustomJobTypeValue(cacheKey, sourceField = '', sourceValue, targetField, lob, fba) {
  let result = []
  if (basicDataCacheMap.has(cacheKey)) {
    result = basicDataCacheMap.get(cacheKey)
  }
  let targetValue = ''
  if (sourceField && targetField) {
    const entity = result.find(item => {
      return item[sourceField] === sourceValue && item['type'] === lob && item['fba'] === fba
    })
    if (entity) {
      targetValue = entity[targetField] || ''
    }
  }
  return targetValue
}

/**
 * 根据字段值解析为转换后的值（忽略大小写）
 * @param cacheKey
 * @param sourceField
 * @param sourceValue
 * @param targetField
 * @param refreshCache
 * @returns {Promise<[]>}
 */
export function resolveSpecificField2ValueIgnoreCase(cacheKey, sourceField = '', sourceValue, targetField, isNeedObject = false, compareFirstPart = false, methodParams) {
  if (typeof sourceValue === 'string') {
    sourceValue = sourceValue.toUpperCase()
  }
  let result = []
  if (basicDataCacheMap.has(cacheKey)) {
    result = basicDataCacheMap.get(cacheKey)
    if (result && methodParams) {
      result = result.filter(item => {
        // 遍历 methodParams 对象中的每一个键值对
        return Object.keys(methodParams).every(key => {
          if (key === METHOD_PARAMS_KEY_COMPANY_LOB.code) {
            return item[methodParams[key]] === true
          }
          return item[key] === methodParams[key]
        })
      })
    }
  }

  // console.log('sourceValue', sourceValue, sourceField, targetField)
  let targetValue = ''
  if (sourceField && targetField) {
    const entity = result.find(item => {
      if (typeof sourceValue === 'string' && typeof item[sourceField] === 'string') {
        let value = item[sourceField]
        if (value && compareFirstPart) {
          value = value.split(',')[0]
        }
        return value.toUpperCase() === sourceValue
      }
      return item[sourceField] == sourceValue
    })
    if (entity) {
      if (isNeedObject) {
        targetValue = entity
      } else {
        targetValue = entity[targetField] || ''
      }
    }
  }
  // console.log(cacheKey, 'targetValue', targetValue)
  return targetValue
}

export function resolveSpecificField2Item(cacheKey, sourceField = '', sourceValue) {
  let result = []
  if (basicDataCacheMap.has(cacheKey)) {
    result = basicDataCacheMap.get(cacheKey)
  }
  // console.log('sourceValue', sourceValue, sourceField, targetField)
  if (sourceField) {
    const entity = result.find(item => {
      return item[sourceField] === sourceValue
    })
    if (entity) {
      return entity
    }
  }
  // console.log(cacheKey, 'targetValue', targetValue)
  return null
}
// 自定义业务类型需要根据lob和code 一起进行区分
export function resolveSpecificField2ItemByCustomType(cacheKey, sourceField = '', sourceValue, lob) {
  let result = []
  if (basicDataCacheMap.has(cacheKey)) {
    result = basicDataCacheMap.get(cacheKey)
  }
  if (sourceField) {
    const entity = result.find(item => {
      return item[sourceField] === sourceValue && item['type'] === lob
    })
    if (entity) {
      return entity
    }
  }
  return null
}
/**
 * 根据字段值解析处转换后的值 todo
 * @param cacheKey
 * @param sourceField
 * @param sourceValue
 * @param targetField
 * @param refreshCache
 * @returns {Promise<[]>}
 */
export async function resolveSpecificField2Value2(cacheKey, sourceField = '', sourceValue, targetField, refreshCache = false) {
  const result = await getSpecificBasicData(cacheKey, refreshCache)
  // console.log('sourceValue', sourceValue, sourceField, targetField)
  let targetValue = ''
  if (sourceField && targetField) {
    const entity = result.find(item => {
      return item[sourceField] === sourceValue
    })
    if (entity) {
      targetValue = entity[targetField] || ''
    }
  }
  // console.log(cacheKey, 'targetValue', targetValue)
  return targetValue
}

function objToStrMap(obj) {
  const strMap = new Map()
  for (const k of Object.keys(obj)) {
    obj[k] = sortCacheValue(basicDataCacheKeyPrefix + k, obj[k])
    strMap.set(basicDataCacheKeyPrefix + k, obj[k])
  }
  return strMap
}
export async function syncInitCache() {
  const res = await initCache()
  basicDataCacheMap.clear()
  basicDataCacheMap = objToStrMap(res.data)
  CommonUtil.setTimeZoneAfterCache() // 缓存更新之后为当前分公司所设置的时区
}
export function syncAllBasicData() {
  store.dispatch('cache/setLoadingCacheKey', '')
  loadAllBasicInfo().then(res => {
    basicDataCacheMap.clear()
    basicDataCacheMap = objToStrMap(res.data)
    store.dispatch('cache/setLoadingStatus', true)
    store.dispatch('cache/setLoadingCacheKey', cacheKeys.basic_data_Company)
    CommonUtil.setTimeZoneAfterCache() // 缓存更新之后为当前分公司所设置的时区
  })
  afterSyncAllBasicData()
}
export async function refreshBasicData() {
  store.dispatch('cache/setLoadingStatus', false)
  store.dispatch('cache/setLoadingCacheKey', '')
  return loadAllBasicInfo().then(res => {
    basicDataCacheMap.clear()
    basicDataCacheMap = objToStrMap(res.data)
    store.dispatch('cache/setLoadingStatus', true)
    store.dispatch('cache/setLoadingCacheKey', cacheKeys.basic_data_Company)
    CommonUtil.setTimeZoneAfterCache() // 缓存更新之后为当前分公司所设置的时区
  })
}
export function syncPortionBasicData() {
  const blockCacheName = ['Continent', 'AdministrativeDivision', 'Vessel', 'Country', 'Network', 'FeeFcl', 'PortGroup', 'OtherChargeItem', 'PriceServiceAir', 'AirRoute', 'AirRegion',
    'EntityTriggerType', 'MscServiceCode', 'SubLocation', 'Wharf', 'InnerPackage', 'MscImoSort', 'MscSegGroup', 'ChargeUnit', 'CargoInformation']
  getPortionCacheVersions({ excludeCache: blockCacheName.join(',') }).then(res => {
    console.log('cache', res.data)
    basicDataCacheMap.clear()
    basicDataCacheMap = objToStrMap(res.data)
    store.dispatch('cache/setLoadingStatus', true)
    afterSyncAllBasicData()
    CommonUtil.setTimeZoneAfterCache() // 缓存更新之后为当前分公司所设置的时区
  })
}

function afterSyncAllBasicData() {
  // todo
}

export async function syncSpecificBasicData(cacheKey) {
  store.dispatch('cache/setLoadingStatus', false)
  store.dispatch('cache/setLoadingCacheKey', '')
  const simpleCachekey = cacheKey.replace(basicDataCacheKeyPrefix, '')
  const res = await loadSpecificBasicInfo(simpleCachekey)
  let cacheValue = res.data
  if (basicDataCacheMap.has(cacheKey)) {
    cacheValue = sortCacheValue(cacheKey, cacheValue)
    basicDataCacheMap.set(cacheKey, cacheValue)
  }
  store.dispatch('cache/setLoadingStatus', true)
  store.dispatch('cache/setLoadingCacheKey', cacheKey)
}

function sortCacheValue(cacheKey, cacheValue) {
  if (cacheKey === cacheKeys.basic_data_CargoType && cacheValue && cacheValue.length > 0) {
    cacheValue = cacheValue.sort((a, b) => a.serialNumber - b.serialNumber)
  }
  return cacheValue
}

export async function updateSpecificBasicData(cacheKey) {
  store.dispatch('cache/setLoadingStatus', false)
  store.dispatch('cache/setLoadingCacheKey', '')
  const simpleCachekey = cacheKey.replace(basicDataCacheKeyPrefix, '')
  const res = await updateCacheSpecificBasicData(simpleCachekey)
  let cacheValue = res.data
  if (basicDataCacheMap.has(cacheKey)) {
    cacheValue = sortCacheValue(cacheKey, cacheValue)
    basicDataCacheMap.set(cacheKey, cacheValue)
  }
  store.dispatch('cache/setLoadingStatus', true)
  store.dispatch('cache/setLoadingCacheKey', cacheKey)
}

export function hasCache() {
  return basicDataCacheMap.size > 0
}

/**
 * 根据缓存Key解析处转换后的值
 * @param cacheKey
 * @param sourceField
 * @param sourceValue
 * @param targetField
 * @param refreshCache
 * @returns {Promise<[]>}
 */
export function getFilterCacheList(cacheKey, filterCallback) {
  let filterResult = []
  if (basicDataCacheMap.has(cacheKey)) {
    const result = basicDataCacheMap.get(cacheKey)
    filterResult = filterCallback ? result.filter(item => filterCallback(item)) : result
  }
  return filterResult
}

/**
 * 根据缓存Key以及条件取对象
 * @param cacheKey
 * @param field
 * @param fieldValue
 * @returns Object
 */
export function getObjectByCache(cacheKey, field, fieldValue) {
  if (basicDataCacheMap.has(cacheKey)) {
    const result = basicDataCacheMap.get(cacheKey)
    const entity = result.find(item => {
      return item[field] === fieldValue
    })
    if (entity) {
      return entity
    }
  }
  return null
}

/**
 * 从缓存中获取匹配对象
 * @param {string} cacheKey - 缓存键名
 * @param fields
 * @param {string} searchValue - 检索的值
 * @return {Object|null} - 返回匹配的对象，如果没有匹配则返回null
 */
export function getObjectByCacheMatchFiled(cacheKey, fields = [], searchValue) {
  // 参数验证
  if (!cacheKey || !searchValue || !fields || !Array.isArray(fields) || !fields.length) {
    return null
  }

  // 检查缓存是否存在
  if (basicDataCacheMap.has(cacheKey)) {
    const array = basicDataCacheMap.get(cacheKey)

    return array.find(item => {
      // 只检查指定的属性
      return fields.some(fieldName => {
        // 确保对象有该属性且属性值不为null/undefined
        if (item[fieldName] !== null && item[fieldName] !== undefined) {
          return String(item[fieldName]).toUpperCase() === String(searchValue).toUpperCase()
        }
        return false
      })
    }) || null
  }

  return null
}

/**
 * 根据缓存Key取缓存list
 * @param cacheKey
 */
export function getCacheListByKey(cacheKey) {
  if (basicDataCacheMap.has(cacheKey)) {
    return basicDataCacheMap.get(cacheKey)
  }
  return []
}

export function getDepartmentAllDepartmentByOfficeId(officeUuid) {
  let tempOfficeAllDepartmentMap = new Map()
  if (basicDataCacheMap.has(cacheKeys.basic_data_OfficeDepartmentAllDepartmentMap)) {
    tempOfficeAllDepartmentMap = basicDataCacheMap.get(cacheKeys.basic_data_OfficeDepartmentAllDepartmentMap)
    // return tempOfficeAllDepartmentMap.get(officeId)
  }

  if (tempOfficeAllDepartmentMap.has(officeUuid)) {
    return tempOfficeAllDepartmentMap.get(officeUuid)
  } else {
    // 从缓存中中 遍历找 office和部门-子部门
    const allCacheDepartments = getCacheListByKey(cacheKeys.basic_data_Department)
    const targetDeptMap = new Map()
    const initDeptUuids = []

    // todo-shengsheng  Desc: 获取公司下的部门
    // 第一级部门
    allCacheDepartments.forEach(dept => {
      if (dept.officeUuid === officeUuid) {
        initDeptUuids.push(dept.uuid)
      }
    })

    getAllDepartmentByDeptId(allCacheDepartments, targetDeptMap, initDeptUuids)
    const targetDeptUuids = [...targetDeptMap.keys()]

    const allCacheDepts = getCacheListByKey(cacheKeys.basic_data_Department)
    const resultDepts = allCacheDepts.filter(dept => targetDeptUuids.includes(dept.uuid))

    tempOfficeAllDepartmentMap.set(officeUuid, resultDepts)
    basicDataCacheMap.set(cacheKeys.basic_data_OfficeDepartmentAllDepartmentMap, tempOfficeAllDepartmentMap)
    return resultDepts
  }
}

export function getOfficeAllDepartmentByOfficeId(officeUuid) {
  let tempOfficeAllDepartmentMap = new Map()
  if (basicDataCacheMap.has(cacheKeys.basic_data_OfficeAllDepartmentMap)) {
    tempOfficeAllDepartmentMap = basicDataCacheMap.get(cacheKeys.basic_data_OfficeAllDepartmentMap)
    // return tempOfficeAllDepartmentMap.get(officeId)
  }

  if (tempOfficeAllDepartmentMap.has(officeUuid)) {
    return tempOfficeAllDepartmentMap.get(officeUuid)
  } else {
    // 从缓存中中 遍历找 office和部门
    const allCacheOffices = getCacheListByKey(cacheKeys.basic_data_Office_All)
    const targetOfficeMap = new Map()

    getAllOfficeByOfficeId(allCacheOffices, targetOfficeMap, [officeUuid])
    const targetOfficeUuids = [...targetOfficeMap.keys()]

    const allCacheDepts = getCacheListByKey(cacheKeys.basic_data_Department_All)
    const resultDepts = allCacheDepts.filter(dept => targetOfficeUuids.includes(dept.officeUuid))

    tempOfficeAllDepartmentMap.set(officeUuid, resultDepts)
    basicDataCacheMap.set(cacheKeys.basic_data_OfficeAllDepartmentMap, tempOfficeAllDepartmentMap)
    return resultDepts
  }
}

/**
 *
 * @param sourceOffices 待遍历的公司源
 * @param targetOffices 符合条件的结果
 * @param officeIds
 */
function getAllOfficeByOfficeId(sourceOffices, targetOfficeMap, officeUuids) {
  if (officeUuids.length <= 0) {
    return
  }

  const tempSourceOffices = []
  const tempOfficeUuids = []

  sourceOffices.forEach(office => {
    // 优化为 两步判断的，故意为之
    if (officeUuids.includes(office.uuid)) {
      targetOfficeMap.set(office.uuid, office)
    } else if (officeUuids.includes(office.parentBranchUuid)) {
      tempOfficeUuids.push(office.uuid)
      targetOfficeMap.set(office.uuid, office)
    } else {
      tempSourceOffices.push(office)
    }
  })

  getAllOfficeByOfficeId(tempSourceOffices, targetOfficeMap, tempOfficeUuids)
}

/**
 *
 * @param sourceDeptMap 待遍历的部门源
 * @param targetDeptMap 符合条件的结果
 * @param deptIds
 */
function getAllDepartmentByDeptId(sourceDepts, targetDeptMap, deptUuids) {
  if (deptUuids.length <= 0) {
    return
  }

  const tempSourceDepts = []
  const tempDeptUuids = []

  sourceDepts.forEach(dept => {
    // 优化为 两步判断的，故意为之
    if (deptUuids.includes(dept.uuid)) {
      targetDeptMap.set(dept.uuid, dept)
    } else if (deptUuids.includes(dept.parentDepartmentUuid)) {
      tempDeptUuids.push(dept.uuid)
      targetDeptMap.set(dept.uuid, dept)
    } else {
      tempSourceDepts.push(dept)
    }
  })

  getAllDepartmentByDeptId(tempSourceDepts, targetDeptMap, tempDeptUuids)
}

/**
 * 更新基础数据缓存（单个）
 * @param cacheKey
 * @param item
 * @returns {Promise<void>}
 */
export async function updateBasicDataForSingle(cacheKey, item) {
  if (basicDataCacheMap.has(cacheKey)) {
    const list = basicDataCacheMap.get(cacheKey)
    let isExist = false
    for (const row of list) {
      if (row.uuid && item.uuid && row.uuid === item.uuid) {
        Object.assign(row, item)
        isExist = true
        break
      }
    }
    if (!isExist) {
      list.push(item)
    }
    store.dispatch('cache/setLoadingStatus', false)
    store.dispatch('cache/setLoadingCacheKey', '')
    setTimeout(() => {
      store.dispatch('cache/setLoadingStatus', true)
      store.dispatch('cache/setLoadingCacheKey', cacheKey)
    })
  }
}

/**
 * 根据配置委托级别获取分公司
 * CARGO-38276 组织架构固定的情况下操作人员录单时可以选到本省全部的操作公司
 */
export function getBranchByLevel(officeId) {
  const result = getCacheListByKey(cacheKeys.basic_data_Office_All)
  const isDepartmentSee = checkPermission(['roleGroup_Common_regionalCommission']) // 是否拥有区域内委托权限
  const level = Number(cache.config.get('RegionalCommission'))
  const currentOffice = $store.getters.currentOffice
  if (isDepartmentSee && level > 0 && level <= currentOffice.level) {
    if (!result || result.length <= 0) {
      return []
    }
    // 获取当前公司的级别差
    let levelDiff = currentOffice.level - level
    // 获取配置的分公司
    let corp = currentOffice
    while (levelDiff > 0) {
      corp = result.find(item => item.uuid === corp.parentBranchUuid)
      levelDiff--
    }
    // 获取当前分公司下的所有子公司
    if (corp) {
      const allChildCompaniesA = getAllChildCompanies(result, corp.uuid)
      allChildCompaniesA.push(corp)
      const exist = allChildCompaniesA.some(obj => obj['officeId'] === officeId)
      if (!exist) {
        const dqgs = result.find(item => item.officeId === officeId)
        if (dqgs) {
          allChildCompaniesA.push(dqgs)
        }
      }
      return allChildCompaniesA
    } else {
      return result
    }
  } else {
    return result
  }
}

export function operateBranchIsOptional() {
  const isDepartmentSee = checkPermission(['roleGroup_Common_regionalCommission']) // 是否拥有区域内委托权限
  const level = Number(cache.config.get('RegionalCommission'))
  const currentOfficeLevel = $store.getters.currentOfficeLevel
  return (isDepartmentSee && level >= 0 && level <= currentOfficeLevel)
}

function getAllChildCompanies(companies, parentUuid) {
  const result = []
  for (const company of companies) {
    if (company.parentBranchUuid === parentUuid) {
      const childCompanies = getAllChildCompanies(companies, company.uuid)
      result.push(company, ...childCompanies)
    }
  }
  return result
}
